import * as React from 'react';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';

import logo from 'assets/logo.svg';

import './Auth.css';
import { IconButton, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
interface AuthLayoutProps {
    children: React.ReactNode;
    showBackButton?: boolean;
}

export default function AuthLayaout({ children, showBackButton }: AuthLayoutProps) {
    const navigate = useNavigate();

    const handleBackClick = () => {
        navigate(-1);
    };
    return (
        <div className="Auth-body">
            <div className="Auth-container">
                <div className="Auth-container-logo">
                    {showBackButton && (
                        <Stack direction="row" alignItems="center" sx={{ position: 'absolute', left: '10px', top: '10px' }}>
                            <IconButton onClick={handleBackClick}>
                                <KeyboardBackspaceIcon />
                            </IconButton>
                            <Typography>Back</Typography>
                        </Stack>
                    )}
                    <img src={logo} className="Auth-logo" alt="logo" />
                    <p className="Auth-logo-title">Catholic Community</p>
                </div>
                <Stack width="100%">{children}</Stack>
            </div>
        </div>
    );
}
